import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { useGetIpv6Group } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveIpv6Group } from '../../shared/components';

export type UpdateIpv6GroupPageProps = {};

const UpdateIpv6GroupPage: React.FC<UpdateIpv6GroupPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_grupoipv6);
  const returnUrlIPv6Page = ROUTER_PATHS.configuracionRED.grupoIpv6Nav;

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetIpv6Group(id!);

  if (isLoading || isRefetching) return <LoaderComponent />;
  if (!data?.data?.id_grupoipv6) return <Navigate to={returnUrlIPv6Page} />;

  return (
    <SaveIpv6Group titlePage="Editar Grupo IPv6" editIpv6Group={data.data} />
  );
};

export default UpdateIpv6GroupPage;
